import { REDUCE_QUERY_ELEMENT } from '../../constants/actions/policies';

export function reduceQueryElement(payload) {
    return {
        type: REDUCE_QUERY_ELEMENT,
        payload,
    };
}
